import { ReactNode } from "react";
import { Archive, ChevronDown } from "lucide-react";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { Card, CardContent } from "@/components/ui/card";

interface Props {
  count: number;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: ReactNode;
}

export const ArchiveSection = ({ count, open, onOpenChange, children }: Props) => (
  <Collapsible open={open} onOpenChange={onOpenChange} className="mt-8">
    <CollapsibleTrigger className="flex w-full items-center gap-2 rounded-md border border-dashed border-border px-4 py-3 text-left text-sm font-medium text-muted-foreground transition-colors hover:bg-muted/60">
      <Archive className="h-4 w-4" />
      Archiv ({count})
      <span className="ml-1 text-xs font-normal">abgeschlossen, schreibgeschützt</span>
      <ChevronDown className={`ml-auto h-4 w-4 transition-transform ${open ? "rotate-180" : ""}`} />
    </CollapsibleTrigger>
    <CollapsibleContent>
      <Card className="mt-2 bg-muted/30 opacity-90">
        <CardContent className="p-0">{children}</CardContent>
      </Card>
    </CollapsibleContent>
  </Collapsible>
);

export const ClosedBadge = ({ closedAt }: { closedAt: string }) => (
  <span className="mt-1 inline-flex items-center gap-1 rounded-full bg-muted px-2 py-0.5 text-xs text-muted-foreground">
    <Archive className="h-3 w-3" /> abgeschlossen {new Date(closedAt).toLocaleDateString("de-DE")}
  </span>
);
